import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { appService } from "../../../_services/app.service";
import { environment } from "../../../../environments/environment";
import { TranslateConfigService } from "../translateConfig.service";
import { CommonService } from "../../../_services/common.service";
import { DatePipe } from "@angular/common";
import { Router } from "@angular/router";
import { CookieService } from "ngx-cookie-service";
import { HttpClient } from "@angular/common/http";
import { Helpers } from "../../../../app/helpers";
import { DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';
const LNG_KEY = "SELECTED_LANGUAGE";
declare var $: any;
declare var moment: any;

@Component({
  selector: "app-main",
  templateUrl: "./main.component.html",
  styleUrls: ["./main.component.scss"]
})
export class MainComponent implements OnInit {

  selectedLang: string;
  hostUrl: any = environment.apiUrl;
  LoadData: any;
  LoadDataFilter: any = {};
  DateOn: any;
  static mainComponent: MainComponent;
  isLogged: boolean = false;
  RateCheck: any = {};
  isRateCheckclick: boolean = false;
  VehicleTypeList: any = [];
  TypeOfVehicle: any;
  WaitingTime: number = 0;

  OriginPHolder: string = '';
  DestinationPHolder: string = '';
  // VehicleTypePHolder: string = '';

  constructor(
    private translate: TranslateService,
    private service1: TranslateConfigService,
    private _appService: appService,
    private toastr: ToastrService,
    private commonService: CommonService,
    public datepipe: DatePipe,
    private router: Router,
    private cookieService: CookieService,
    private http: HttpClient,
    private decryptpipe: DecryptPipe
  ) {
    MainComponent.mainComponent = this;

    let language = this.translate.getBrowserLang();
    let value = localStorage.getItem(LNG_KEY);
    if (value === "" || value === null || value === undefined) {
      this.translate.setDefaultLang(language);
      this.selectedLang = language;
    } else {
      this.service1.setLanguage(value);
      this.selectedLang = value;
    }
    let val = localStorage.getItem(LNG_KEY);
  }

  ngOnInit() {
    this.CheckUserStatus();
    this.RefreshvalidDate();
    this.LoadVehicleType();
    this.LoadOrigin();
    this.LoadDestination();

    this.TypeOfVehicle = "0";

    if (localStorage.getItem('isPreCustomer') == 'true') {
      var dataList = JSON.parse(localStorage.getItem('OnSelectPreCus'));

      var OptionsFromCity = "";
      OptionsFromCity += '<option value="' + dataList.FromCity + '">' + dataList.FromCity + "</option>";
      $("#se2-Origin").html(OptionsFromCity);
      $("#se2-Origin").val(dataList.FromCity).change();

      var OptionsToCity = "";
      OptionsToCity += '<option value="' + dataList.ToCity + '">' + dataList.ToCity + "</option>";
      $("#se2-Destionation").html(OptionsToCity);
      $("#se2-Destionation").val(dataList.ToCity).change();

      var DateOn = moment(new Date(dataList.DateOn)).format(
        "DD-MMM-YYYY HH:mm:ss"
      );
      $("#DateOn").val(DateOn);

      this.TypeOfVehicle = dataList.VehicleTypeId.toLowerCase();
    }

    if (localStorage.getItem('isRateCheckClick') == 'true') {
      this.isRateCheckclick = true;
    } else {
      this.isRateCheckclick = false;
    }
  }

  CheckUserStatus() {
    if (localStorage.getItem('user_Type_Rights') == null || localStorage.getItem('user_Type_Rights') == undefined) {
      this.isLogged = false;
      localStorage.removeItem('isRateCheckClick');
    } else {
      this.isLogged = true;
    }
  }


  RefreshvalidDate() {
    setTimeout(() => {
      $(".datetimepicker").datepicker({
        todayHighlight: !0,
        orientation: "auto",
        autoclose: true,
        format: "dd-M-yyyy",
        setDate: new Date(),
        templates: {
          leftArrow: '<i class="la la-angle-left"></i>',
          rightArrow: '<i class="la la-angle-right"></i>',
        },
      });
    }, 200);
  }

  LoadVehicleType() {
    var apiUrl = environment.apiUrl + "api/VehicleMaster/GetVehicleList";
    this.http.get(apiUrl).subscribe(
      (response: any) => {
        this.VehicleTypeList = response.Results;
      },
      (err) => {
        this.toastr.error(
          "Error occurred while fetching Status data !",
          "error"
        );
      }
    );
  }

  LoadOrigin() {
    $("#se2-Origin").select2({
      width: "90%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url: environment.apiUrl + "api/Company/GetCitySearchList2",
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          $("#se2-Origin").text("");
          return {
            query: params.term,
            CategoryName: "City",
          };
        },
        processResults: function (data) {
          return {
            results: data,
          };
        },
      },
      tokenSeparators: [","],
      placeholder: MainComponent.mainComponent.selectedLang == 'en' ? 'Search Origin' : 'Origen de la búsqueda',
    });
  }

  LoadDestination() {
    $("#se2-Destionation").select2({
      width: "96%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url: environment.apiUrl + "api/Company/GetCitySearchList2",
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          $("#se2-Destionation").text("");
          return {
            query: params.term,
            CategoryName: "City",
          };
        },
        processResults: function (data) {
          return {
            results: data,
          };
        },
      },
      tokenSeparators: [","],
      placeholder: MainComponent.mainComponent.selectedLang == 'en' ? 'Search Destination' : 'Buscar destino',
    });
  }

  OnSearchClick() {
    Helpers.setLoading(true);
    this.CheckUserStatus();

    if (
      !this.commonService.ValidateRequiredField(
        $("#se2-Origin"),
        "Please select the Origin",
        "after",
        ""
      )
    ) {
      return;
    } else {
      this.commonService.ClearMessage($("#se2-Origin"));
    }

    if (
      !this.commonService.ValidateRequiredField(
        $("#se2-Destionation"),
        "Please select the Destionation",
        "after",
        ""
      )
    ) {
      return;
    } else {
      this.commonService.ClearMessage($("#se2-Destionation"));
    }

    if (
      !this.commonService.ValidateRequiredField(
        $("#se2-TypeOfVehicle"),
        "Please select the Type Of Vehicle",
        "after",
        ""
      )
    ) {
      return;
    } else {
      this.commonService.ClearMessage($("#se2-TypeOfVehicle"));
    }

    if (
      !this.commonService.ValidateRequiredField(
        $("#DateOn"),
        "Please select the Date",
        "after",
        ""
      )
    ) {
      return;
    } else {
      this.commonService.ClearMessage($("#DateOn"));
    }

    var apiUrl = environment.apiUrl + "api/OrdersByVehicle/GetLoadData";

    if (localStorage.getItem('isPreCustomer') == 'true') {
      var dataList = JSON.parse(localStorage.getItem('OnSelectPreCus'));

      this.LoadDataFilter.Origin = dataList.FromCity;
      this.LoadDataFilter.Destination = dataList.ToCity;
      this.LoadDataFilter.VehicleType = dataList.VehicleTypeId;
      this.LoadDataFilter.Date = moment(dataList.DateOn).format(
        "DD-MMM-YYYY HH:mm:ss"
      );

      localStorage.removeItem('OnSelectPreCus');
      localStorage.removeItem('isPreCustomer');
    } else {
      this.LoadDataFilter.Origin = $("#se2-Origin").val();
      this.LoadDataFilter.Destination = $("#se2-Destionation").val();
      this.LoadDataFilter.VehicleType = $("#se2-TypeOfVehicle").val();
      this.LoadDataFilter.Date = moment($("#DateOn").val()).format(
        "DD-MMM-YYYY HH:mm:ss"
      );
    }

    console.log(this.LoadDataFilter);

    this.http.post(apiUrl, this.LoadDataFilter).subscribe((response) => {
      var data = response[0]['Column1'];
      this.LoadData = JSON.parse(data);
      console.log(this.LoadData);
      this.SaveRateCheck();

      if (this.isLogged == false) {
        $("#SearchModal").modal("show");
      }
      Helpers.setLoading(false);
    },
      (err) => {
        alert('error');
        console.log(err);
        Helpers.setLoading(false);
        this.toastr.error("An error occured printing !", "error");
      }
    );
  }

  onSelect(FromCity: any, ToCity: any, VehicleTypeId: any, VehicleType: any, WaitingTime: any) {
    var dataList = {
      FromCity: FromCity,
      ToCity: ToCity,
      VehicleTypeId: VehicleTypeId,
      VehicleType: VehicleType,
      WaitingTime: WaitingTime
    }

    localStorage.removeItem('OnSelectLoad');
    localStorage.setItem('OnSelectLoad', JSON.stringify(dataList));

    let UserRole = this.decryptpipe.transform(JSON.parse(this.cookieService.get("SetUserRole")));
    var EmailAddress = JSON.parse(localStorage.getItem("ChnageCompnayId")).SelectedComapnyEmail;

    if (this.isLogged == true) {

      if (UserRole == '["Pre-Customer"]') {
        this.toastr.warning(this.translate.instant("ALERTMESSAGES.PreCusWarning") + ' ' + EmailAddress);
      } else {
        this.router.navigate(['/ByCustomer']);
      }

    } else {
      this.router.navigate(['/home']);
    }
  }

  SaveRateCheck() {

    this.RateCheck.Origin = $("#se2-Origin").val();
    this.RateCheck.Destination = $("#se2-Destionation").val();
    this.RateCheck.VehicleTypeId = $("#se2-TypeOfVehicle").val();
    this.RateCheck.SearchDate = moment($("#DateOn").val()).format(
      "YYYY-MM-DD hh:MM:ss"
    );

    if (this.isLogged == true) {
      this.RateCheck.UserId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    } else {
      this.RateCheck.UserId = null;
    }

    var apiUrl = environment.apiUrl + "api/OrdersByVehicle/SaveRateCheck";

    this.http.post(apiUrl, this.RateCheck).subscribe((response) => {
      // this._appService.Post("OrdersByVehicle", "SaveRateCheck", this.RateCheck).subscribe((response) => {
      console.log(response);
    },
      (err) => {
        this.toastr.error("An error occured printing !", "error");
      }
    );
  }

  OnRegister(FromCity: any, ToCity: any, VehicleTypeId: any, VehicleType: any) {
    localStorage.removeItem('isPreCustomer');
    localStorage.setItem('isPreCustomer', 'true');

    var selectedDate = moment($("#DateOn").val()).format(
      "YYYY-MM-DD hh:MM:ss"
    );

    var dataList = {
      FromCity: FromCity,
      ToCity: ToCity,
      VehicleTypeId: VehicleTypeId,
      VehicleType: VehicleType,
      DateOn: selectedDate
    }

    localStorage.removeItem('OnSelectPreCus');
    localStorage.setItem('OnSelectPreCus', JSON.stringify(dataList));

    this.router.navigate(['/home/tabs/signup/customer'])
  }

  onChangeValue(value: any, i: any) {
    if (value == null || value == undefined) {
      this.WaitingTime = 0;
    } else {
      this.WaitingTime = value;
    }
  }

  OnRegisterBtn() {
    var Origin = $("#se2-Origin").val();
    var Destination = $("#se2-Destionation").val();
    var VehicleTypeId = $("#se2-TypeOfVehicle").val();
    var VehicleType = $("#se2-TypeOfVehicle").text();

    localStorage.removeItem('isPreCustomer');
    localStorage.setItem('isPreCustomer', 'true');

    var selectedDate = moment($("#DateOn").val()).format(
      "YYYY-MM-DD hh:MM:ss"
    );

    var dataList = {
      FromCity: Origin,
      ToCity: Destination,
      VehicleTypeId: VehicleTypeId,
      VehicleType: VehicleType,
      DateOn: selectedDate
    }

    localStorage.removeItem('OnSelectPreCus');
    localStorage.setItem('OnSelectPreCus', JSON.stringify(dataList));

    $("#SearchModal").modal("hide");
    this.router.navigate(['/home/tabs/signup/customer'])
  }
}
